import { ReactNode, createContext } from 'react';

import * as api from '../api';

import type { ChatConversation } from '../common';

export type ConversationContextProps = {
  messages: ChatConversation[];
  addNewMessage: (newMessage: ChatConversation) => void;
  updateCurrentMessage: (message: ChatConversation) => void;
  upsertLastMessage: (
    message: ChatConversation,
    intentComponent?: api.Assistant.IntentComponent,
  ) => void;
  disableMessages: (intent?: api.Assistant.Intent) => void;
  resetConversation: () => void;
  removeLastMessage: () => void;
  setPanelContent: (content: ReactNode | null) => void;
  panelContent: ReactNode | null;
};

export const ConversationContext = createContext<
  ConversationContextProps | undefined
>(undefined);
